import React, { useEffect, useState } from 'react';
import NeuroAgeLifestyleQuiz from './components/NeuroAgeLifestyleQuiz';
import NeuroAgeAdminDashboard from './components/NeuroAgeAdminDashboard';
import './App.css';

function App() {
  const [showAdmin, setShowAdmin] = useState(false);

  useEffect(() => {
    // Check URL parameters on mount and when URL changes
    const checkAuth = () => {
      const urlParams = new URLSearchParams(window.location.search);
      setShowAdmin(urlParams.has('auth'));
    };

    // Initial check
    checkAuth();

    // Listen for URL changes (in case of programmatic navigation)
    window.addEventListener('popstate', checkAuth);

    return () => {
      window.removeEventListener('popstate', checkAuth);
    };
  }, []);

  return (
    <div className="App">
      <main>
        {showAdmin ? <NeuroAgeAdminDashboard /> : <NeuroAgeLifestyleQuiz />}
      </main>
    </div>
  );
}

export default App;